import React from 'react';
import AntSpin, { SpinProps } from 'antd/lib/spin';
import { LoaderIcon } from '@revfluence/fresh-icons/solid';

export interface ISpinnerProps extends SpinProps {}

/**
 * Spinner component
 */
export const Spinner: React.FC<ISpinnerProps> = (props) => {
  const { indicator = <LoaderIcon /> } = props;

  return (
    <AntSpin
      {...props}
      indicator={React.cloneElement(indicator, {
        className: 'anticon anticon-spin',
      })}
    />
  );
};
